import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * 2 Cards Teenpatti (casino/patti2) video overlay — reference markup (.casino-table.teenpatti2cards):
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     > div(cards[0], cards[2]) + div(cards[1], cards[3])
 * Hidden while cards[0] is "1" (not dealt) or after the shuffle toggle, like the reference.
 */
export default function Patti2CardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  if (card == null || card === "") return null;
  const cards = String(card).split(",").map((c) => c.trim());
  const hide = !showCards || cards[0] === "1";
  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const img = (token) => (
    <span>
      <CardImg src={getCardImage(token)} alt="" />
    </span>
  );

  return (
    <div className={`casino-video-cards${hide ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <div>
          {img(cards[0])} {img(cards[2])}
        </div>{" "}
        <div>
          {img(cards[1])} {img(cards[3])}
        </div>
      </div>
    </div>
  );
}
